module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_10.cb4e9b55.jpg";